import { db } from "../firebase/firebaseConfig";

import {
    collection,
    addDoc,
    doc,
    getDocs,
    query,
    where,
    writeBatch,
} from "firebase/firestore";

import correlativos from "./correlativosMultiEmpresa";

const generarTraspasoRetornoHomeCare = async ({
    orden,
    userEmail = "",
    linkNotificacion = "",
}) => {

    // ==========================================
    // VALIDACIONES
    // ==========================================

    if (!orden?.id) {
        throw new Error(
            "No se recibió la orden de ingreso ST."
        );
    }

    // Esta orden no proviene de HomeCare.
    // No corresponde generar retorno automático.
    if (
        orden.origen_ingreso !==
        "TRASPASO_ST_INTERNO"
    ) {
        return {
            generado: false,
            motivo: "NO_APLICA",
        };
    }

    // Ya tiene retorno generado.
    if (orden.traspaso_retorno_generado === true) {
        return {
            generado: false,
            motivo: "YA_GENERADO",
            id: orden.id_traspaso_retorno || "",
            folio:
                orden.folio_traspaso_retorno || "",
        };
    }

    if (!orden.emp_id_origen) {
        throw new Error(
            "La orden no tiene emp_id_origen HomeCare."
        );
    }

    if (!orden.eq_id_origen) {
        throw new Error(
            "La orden no tiene asociado el equipo de origen."
        );
    }

    if (!orden.rut_paciente) {
        throw new Error(
            "La orden no tiene asociado el RUT del paciente."
        );
    }

    // ==========================================
    // EVITAR DUPLICADOS
    // ==========================================

    const qExiste = query(
        collection(db, "salidasCab"),
        where(
            "emp_id",
            "==",
            orden.emp_id_origen
        ),
        where(
            "id_ingreso_st",
            "==",
            orden.id
        ),
        where(
            "origen_traspaso",
            "==",
            "RETORNO_ST_INTERNO"
        )
    );

    const snapExiste = await getDocs(qExiste);

    if (!snapExiste.empty) {
        const existente = {
            id: snapExiste.docs[0].id,
            ...snapExiste.docs[0].data(),
        };

        return {
            generado: false,
            motivo: "YA_EXISTE",
            id: existente.id,
            folio: existente.numdoc,
        };
    }

    // ==========================================
    // DATOS SERVICIO TECNICO INTERNO
    // ==========================================

    const stInterno = {
        rut: "76550891-6",
        nombre: "DORMIR BIEN SPA",
    };

    const fecha = new Date();

    // ==========================================
    // NUEVO FOLIO EN TENANT HOMECARE
    // ==========================================

    const nuevoFolio = await correlativos(
        orden.emp_id_origen,
        "traspasos"
    );

    // ==========================================
    // REFERENCIAS FIRESTORE
    // ==========================================

    const cabRef = doc(
        collection(db, "salidasCab")
    );

    const detalleRef = doc(
        collection(db, "salidas")
    );

    const batch = writeBatch(db);

    // ==========================================
    // CABECERA DEL TRASPASO DE RETORNO
    // ==========================================

    batch.set(cabRef, {
        numdoc: nuevoFolio,

        tipdoc: "TRASPASOS",

        date: fecha,

        tipoinout:
            "S.TECNICO A PACIENTE",

        tipmov: 4,

        // ======================================
        // PACIENTE DESTINO
        // ======================================

        rut: orden.rut_paciente || "",
        entidad: orden.paciente || "",

        // ======================================
        // SERVICIO TECNICO ORIGEN
        // ======================================

        rutSt: stInterno.rut,
        entidadSt: stInterno.nombre,

        // Estos datos debe completarlos HomeCare
        correo: "",
        patente: "",

        descripcion:
            "Retorno automático desde Servicio Técnico",

        observacion: "",

        url: "",

        // ======================================
        // ESTADO INICIAL
        // ======================================

        confirmado: false,

        retirado: false,

        entregado: false,

        // ======================================
        // TRAZABILIDAD
        // ======================================

        automatico: true,

        origen_traspaso:
            "RETORNO_ST_INTERNO",

        id_ingreso_st:
            orden.id,

        folio_ingreso_st:
            orden.folio || "",

        id_traspaso_origen:
            orden.id_traspaso || "",

        id_mantencion:
            orden.id_mantencion || "",

        // ======================================
        // AUDITORÍA
        // ======================================

        useradd: userEmail,

        usermod: userEmail,

        fechaadd: fecha,

        fechamod: fecha,

        // MUY IMPORTANTE:
        // pertenece al tenant HomeCare
        emp_id: orden.emp_id_origen,
    });

    // ==========================================
    // DETALLE: EQUIPO
    // ==========================================

    batch.set(detalleRef, {
        numdoc: nuevoFolio,

        tipdoc: "TRASPASOS",

        date: fecha,

        tipoinout:
            "S.TECNICO A PACIENTE",

        tipmov: 4,

        // ======================================
        // PACIENTE DESTINO
        // ======================================

        rut: orden.rut_paciente || "",
        entidad: orden.paciente || "",

        correo: "",
        patente: "",

        // ======================================
        // CABECERA
        // ======================================

        cab_id: cabRef.id,

        // ======================================
        // EQUIPO HOMECARE
        // ======================================

        eq_id: orden.eq_id_origen,

        familia: orden.familia || "",
        tipo: orden.tipo || "",
        marca: orden.marca || "",
        modelo: orden.modelo || "",
        serie: orden.serie || "",

        rfid: "",

        // ======================================
        // SERVICIO TECNICO
        // ======================================

        rut_st: stInterno.rut,

        nombre_st: stInterno.nombre,

        destino_st_tipo: "INTERNO",

        contrato_mantencion: true,

        tipo_cubierto_contrato: true,

        // Este es un RETORNO.
        // No debe generar otra orden ST.
        genera_ingreso_st: false,

        ingreso_st_generado: true,

        id_ingreso_st: orden.id,

        folio_ingreso_st:
            orden.folio || "",

        id_mantencion:
            orden.id_mantencion || "",

        genera_certificado: false,

        reset_mantencion: false,

        // ======================================
        // TRAZABILIDAD RETORNO
        // ======================================

        automatico: true,

        origen_traspaso:
            "RETORNO_ST_INTERNO",

        id_traspaso_origen:
            orden.id_traspaso || "",

        // ======================================
        // ESTADO
        // ======================================

        historial: 0,

        confirmado: false,

        observacion: "",

        // ======================================
        // AUDITORÍA
        // ======================================

        useradd: userEmail,

        usermod: userEmail,

        fechaadd: fecha,

        fechamod: fecha,

        emp_id: orden.emp_id_origen,
    });

    // ==========================================
    // ACTUALIZAR ORDEN ST
    // ==========================================

    batch.update(
        doc(db, "ingresostcab", orden.id),
        {
            traspaso_retorno_generado: true,

            id_traspaso_retorno:
                cabRef.id,

            folio_traspaso_retorno:
                nuevoFolio,

            fechamod: fecha,
        }
    );

    // ==========================================
    // EJECUTAR TODO JUNTO
    // ==========================================

    await batch.commit();

    // ==========================================
    // NOTIFICAR HOMECARE
    // ==========================================

    try {
        const qUsuarios = query(
            collection(db, "usuarios"),
            where(
                "emp_id",
                "==",
                orden.emp_id_origen
            )
        );

        const snapUsuarios =
            await getDocs(qUsuarios);

        const destinatarios =
            snapUsuarios.docs
                .map((d) => d.data())
                .filter(
                    (u) =>
                        u.rol === "ADMIN-HC" ||
                        u.rol === "SUPERVISOR-HC"
                )
                .map((u) => u.correo)
                .filter(Boolean);

        if (destinatarios.length > 0) {
            await addDoc(
                collection(db, "notificaciones"),
                {
                    titulo:
                        "Equipo listo para retiro",

                    mensaje:
                        orden.servicio === "PRESUPUESTO"
                            ? `El equipo serie ${orden.serie || ""} ` +
                            `finalizó su reparación correctiva y está listo ` +
                            `para coordinar el retiro desde Servicio Técnico.`
                            : `El equipo serie ${orden.serie || ""} ` +
                            `finalizó su mantención preventiva y está listo ` +
                            `para coordinar el retiro desde Servicio Técnico.`,

                    tipo:
                        "RETORNO_ST_PENDIENTE",

                    emp_id:
                        orden.emp_id_origen,

                    para:
                        destinatarios,

                    link:
                        linkNotificacion,

                    data: {
                        id_traspaso:
                            cabRef.id,

                        folio:
                            nuevoFolio,

                        id_ingreso_st:
                            orden.id,

                        serie:
                            orden.serie || "",
                    },

                    fecha: new Date(),

                    leidaPor: [],
                }
            );
        }
    } catch (errorNotif) {
        // La notificación NO debe impedir
        // que se genere el retorno.
        console.error(
            "Error creando notificación retorno ST:",
            errorNotif
        );
    }

    return {
        generado: true,

        id: cabRef.id,

        folio: nuevoFolio,

        detalleId: detalleRef.id,
    };
};

export default generarTraspasoRetornoHomeCare;